module.exports = __webpack_public_path__ + "img/perfil-generico-04.5b74f26f.png";